import { Component, inject } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { RouterActivityService } from '@raxapp/routing/router-activity.service';
import { combineLatest, delay, of, switchMap } from 'rxjs';
import { BffApiBusyService } from '../../booker-backend-apis/bff-api-busy.service';

export interface BusyIndicatorOptions {
    active: boolean;
}

@Component({
    selector: 'rax-busy-indicator',
    templateUrl: './busy-indicator.component.html',
    styleUrls: ['./busy-indicator.component.css'],
})
export class BusyIndicatorComponent {
    private readonly bffApiBusyService = inject(BffApiBusyService);
    private readonly routerActivityService = inject(RouterActivityService);

    private readonly bffApiIsBusy$ = toObservable(this.bffApiBusyService.isBusy);
    private readonly routerIsNavigating$ = toObservable(this.routerActivityService.isNavigating);

    protected readonly showBusyIndicator = toSignal(
        combineLatest([this.bffApiIsBusy$, this.routerIsNavigating$]).pipe(
            switchMap(([bffApiIsBusy, isNavigating]) => {
                if (bffApiIsBusy || isNavigating) {
                    return of(true).pipe(delay(500));
                } else {
                    return of(false).pipe(delay(1));
                }
            }),
        ),
        { initialValue: false },
    );
}
